/**
 * Dashboard Constants
 * Centralized configuration for cache keys, intervals, and shared values
 */

// ============================================================================
// CACHE CONFIGURATION
// ============================================================================

export const CACHE_KEYS = {
    // Main Dashboard (localStorage - persists across sessions)
    DASHBOARD_CACHE: 'dashboard-cache',
    DASHBOARD_LAST_FETCH: 'dashboard-last-fetch-date',
    DASHBOARD_VISIBLE_TEAMS: 'dashboard-visible-teams',
    // Session flag (sessionStorage - cleared on browser close/new tab)
    SESSION_INITIALIZED: 'dashboard-session-initialized',
};

// ============================================================================
// REFRESH INTERVALS
// ============================================================================

export const REFRESH_INTERVALS = {
    // Cache freshness
    STALE_THRESHOLD: 10 * 60 * 1000,        // 10 minutes
    FRESHNESS_CHECK: 5 * 60 * 1000,         // 5 minutes

    // Auto-refresh intervals
    HEALTH_CHECK: 900000,                    // 15 minutes
    BUDGET_REFRESH: 900000,                  // 15 minutes
    ACTIVE_USERS: 60000,                     // 60 seconds

    // Manual refresh cooldown
    MANUAL_REFRESH_COOLDOWN: 60000,          // 60 seconds
};

// ============================================================================
// DURATION MAPPINGS
// ============================================================================

export const DURATION_MAP = {
    daily: '1d',
    weekly: '7d',
    monthly: '30d',
    yearly: '365d',
};

// ============================================================================
// ADMIN USERS
// ============================================================================

export const ADMIN_USERS = ['ian.w@aware.co.th', 'john.c@aware.co.th', 'steven.p@aware.co.th'];

// ============================================================================
// ============================================================================
// SUPPORT STAFF
// ============================================================================

// Initial support staff list (managed via Pod Config UI)
export const SUPPORT_STAFF_DEFAULT = [
    'alexandre.s@aware.co.th',
    'songkwan.n@aware.co.th',
    'naratthorn.c@aware.co.th',
    'athachai.r@aware.co.th'
];

// ============================================================================
// USAGE COST DASHBOARD
// ============================================================================

export const USAGE_COST_CACHE_TTL_MINUTES = 15;
